import { render, staticRenderFns } from "./FiatRecharge.vue?vue&type=template&id=bdc20c8c"
import script from "./FiatRecharge.vue?vue&type=script&lang=js"
export * from "./FiatRecharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports